import {useEffect, useState} from 'react'
import {BiographyTab} from './tabs/BiographyTab'
import {ProfessionalOverviewTab} from './tabs/ProfessionalOverviewTab'
import {LifestyleTab} from './tabs/LifestyleTab'
import {RecognitionTab} from './tabs/RecognitionTab'
import {ExpertiseTab} from './tabs/ExpertiseTab'
import InfoAdminTab from './tabs/InfoAdminTab'
import InfoFamilyTab from './tabs/InfoFamilyTab'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {hasPermission, hasRole, hasTeamModuleAction} from '../../../utils/permissions'
import {Permission, UserRole} from '../../../constants/roles'
import {KTSVG} from '../../../../_metronic/helpers'
import {Link, useHistory, useLocation} from 'react-router-dom'

interface BiographyTabsProps {
  onTabChange?: (tabId: string) => void
  searchableUser: boolean
}

const tabs = [
  {id: 'bio', label: 'Biography'},
  {id: 'overview', label: 'Professional Overview'},
  {id: 'lifestyle', label: 'Lifestyle'},
  {id: 'recognition', label: 'Recognition'},
  {id: 'expertise', label: 'Expertise'},
  // {id: 'ini', label: 'confidential'},
]

const BiographyTabs: React.FC<BiographyTabsProps> = ({onTabChange, searchableUser}) => {
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const canEditBio = hasRole(user, UserRole.TEAM)
    ? hasTeamModuleAction(user, 'profile', 'canEdit')
    : hasPermission(user, Permission.EDIT_BIOGRAPHY)
  const isExpertPartner =
    user?.role === UserRole.PARTNER &&
    String(user?.partnerType || '').toLowerCase().includes('expert')
  // PR-I-85: Expertise vuelve a mostrarse a members (revierte parte de PR-I-80). Los expert
  // partners siguen sin ver Lifestyle. Members ven Expertise incluso vacia; el boton EDIT
  // (bio-edit-underline-btn mas abajo) es el que dispara la publicacion via /profile/edit-expertise.
  const visibleTabs = isExpertPartner
    ? tabs.filter((t) => t.id !== 'lifestyle')
    : tabs
  const [activeTab, setActiveTab] = useState('bio')
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const option = params.get('option');
    if(option){
      setActiveTab(option)
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth',
        });
      }, 800);
    }else{
      onHandleSelectTab('bio')
    }
  },[])

  const onHandleSelectTab = (tabId: string) => {
    const params = new URLSearchParams(location.search);
    params.set('option', tabId);
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
    setTimeout(() => {
      setActiveTab(tabId)
      onTabChange?.(tabId)
    }, 100);
  }

  return (
    <>
      <div className='bio-tabs'>
        {/* Tabs Header */}
        <div className='nb-pm-tabs-header'>
          <div className='nb-pm-tabs-row'>
            <div className='nb-pm-tabs-list'>
              {visibleTabs.map((tab, index) => (
                <div className='tap-flex-center' key={tab.id}>
                  <div
                    className={`nb-pm-tabs-item ${
                      activeTab === tab.id ? 'nb-pm-tabs-item--active' : ''
                    }`}
                    onClick={() => onHandleSelectTab(tab.id)}
                  >
                    <div className='nb-pm-tabs-item-text'>{tab.label}</div>
                  </div>
                  {index < visibleTabs.length - 1 && (
                    <svg className='ml_3' width='1' height='20' viewBox='0 0 1 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M0.5 0V20' stroke='#B4B4B4' />
                    </svg>
                  )}
                </div>
              ))}
            </div>
            <div className='nb-pm-confidential-btn' onClick={()=>onHandleSelectTab('ini')}>
              <div className='nb-pm-confidential-btn-text'>
                Confidential Info
              </div>
            </div>
          </div>

          {canEditBio && !searchableUser && (
            <div className='bio-tabs-actions-wrapper'>
              <button
                className='bio-edit-underline-btn'
                onClick={() => {
                  const routes: Record<string, string> = {
                    bio: '/biography/overview',
                    overview: '/admin/overview/professional',
                    lifestyle: '/admin/overview/personal',
                    recognition: '/recognition',
                    // PR-I-85: EDIT del member para su Expertise abre el formulario nuevo
                    // /profile/edit-expertise (layout PROFILE). La ruta /expertise queda solo
                    // para el flujo admin (lista de expertises pendientes de aprobar).
                    expertise: '/profile/edit-expertise',
                    ini: '/admin/overview/confidential',
                  }

                  const route = routes[activeTab] || '/admin/overview/profile'
                  history.push(route)
                }}
              >
                <span>EDIT</span>
                <KTSVG path='/media/svg/nobilis/vector1.svg' />
              </button>
            </div>
          )}
        </div>

        {/* Tabs Content */}
        <div className='bio-tabs__content'>
          {activeTab === 'bio' && <BiographyTab />}
          {activeTab === 'overview' && <ProfessionalOverviewTab />}
          {activeTab === 'lifestyle' && <LifestyleTab />}
          {activeTab === 'recognition' && <RecognitionTab />}
          {activeTab === 'expertise' && <ExpertiseTab />}
          {activeTab === 'ini' &&  !searchableUser && (
            <div className='bio-tabs__panel--two-col'>
              <InfoAdminTab />
              <InfoFamilyTab />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {BiographyTabs}
